/**
 * This module specifically patches Immer to prevent the version error
 * It should be imported before any Immer usage
 * 
 * This simplified version focuses on working with Immer v9.0.21
 */

// Import the version utility to ensure consistent version handling
import { getVersion } from './version';

// For TypeScript - declare the global interface
// This needs to be in a module context
export {}
declare global {
  interface Window {
    DATACORD_VERSION: { version: string } | string;
    __IMMER_VERSION__: string;
  }
}

// Get the actual version from our utility
const ACTUAL_VERSION = getVersion();

// Define a global variable for Immer version.
// Do not add `version` to Object.prototype. Libraries such as property-information
// (used by react-markdown) test `'version' in attributes` and then call
// toLowerCase() on the result. A prototype getter makes that check true for every
// object and crashes the app on load.
if (typeof window !== 'undefined') {
  window.__IMMER_VERSION__ = '9.0.21';
}

// Set up global immer version to prevent the error
(function patchImmer() {
  // Ensure DATACORD_VERSION is properly initialized
  if (typeof window !== 'undefined') {
    // Make sure it's an object with a version property
    if (!window.DATACORD_VERSION) {
      window.DATACORD_VERSION = { version: ACTUAL_VERSION };
    } else if (typeof window.DATACORD_VERSION === 'string') {
      const versionStr = window.DATACORD_VERSION;
      window.DATACORD_VERSION = { version: versionStr };
    }
    
    // If the object exists but has no version property, add it
    if (typeof window.DATACORD_VERSION === 'object' && !window.DATACORD_VERSION.version) {
      window.DATACORD_VERSION.version = ACTUAL_VERSION;
    }
    
    console.info('ImmerPatch: Successfully initialized version information');
  }
})();

// Export something to ensure this module is included
export const immerPatchVersion = ACTUAL_VERSION; 